const groupKey = (groupId) => (groupId == null ? null : String(groupId));

export const toUpdateRequest = (template) => ({
  name: (template.name ?? "").trim(),
  description: (template.description ?? "").trim() || null,
  pageHidden: Boolean(template.pageHidden),
  paraHidden: Boolean(template.paraHidden),
  pageWidth: template.pageWidth ?? null,
  paraWidth: template.paraWidth ?? null,
  contentWidth: template.contentWidth ?? null,
  groups: (template.groups ?? []).map((group) => ({
    id: group.id ?? null,
    key: group.key ?? groupKey(group.id),
    name: group.name,
    color: group.color,
    repeatable: Boolean(group.repeatable),
    renamable: Boolean(group.renamable),
  })),
  columns: (template.columns ?? []).map((column) => ({
    id: column.id ?? null,
    groupKey: column.groupKey ?? groupKey(column.groupId),
    name: column.name,
    type: column.type,
    headerColor: column.headerColor ?? "",
    width: column.width ?? null,
    numberFormat: column.numberFormat ?? null,
    numberUnit: column.numberUnit ?? null,
    numberUnitPosition: column.numberUnitPosition ?? null,
    pinned: Boolean(column.pinned),
    repeatable: Boolean(column.repeatable),
    renamable: Boolean(column.renamable),
    values: (column.values ?? []).map(({ value, color }) => ({ value, color })),
  })),
});
